import React, { useState, useEffect, useContext } from "react";
import UserDepartmentReadOnlyRow from "./UserDepartmentReadOnlyRow";
import UserDepartmentTableRow from "./UserDepartmentTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function UserDepartmentTable({ key, setDepartment, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isCompLoading, setIsCompLoading] = useState(false);
	const [isUserLoading, setIsUserLoading] = useState(false);
	const [compDepartments, setCompDepartments] = useState([]);
	const [userDepartments, setUserDepartments] = useState([]);
	const [searchValue, setSearchValue] = useState("");
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		departmentKey: 0,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchCompanyDepartments();
		fetchUserDepartments(searchValue);
	}, []);

	const handleClose = (event) => {
		setDepartment(false);
	};

	function fetchCompanyDepartments() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0) {
			return;
		}

		setIsCompLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				companyId: initialValues.companyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetDepartments", "/Service/CompanyService/GetDepartments", requestOptions, retrieveDepartmentSuccess, retrieveDepartmentFail);
		} catch (error) {
			setIsCompLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveDepartmentFail(redirect) {
		setIsCompLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.deptNotRetrieved"));
	}

	function retrieveDepartmentSuccess(responseData) {
		let fetchDepartmentsResponse;
		if (responseData) {
			fetchDepartmentsResponse = responseData.fetchDepartmentsResponse;
			if (fetchDepartmentsResponse && fetchDepartmentsResponse.errorCode === "0") {
				setCompDepartments(fetchDepartmentsResponse.departments.slice())
			} else if (fetchDepartmentsResponse && fetchDepartmentsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchDepartmentsResponse) {
				setError(t("error.error") + " " + fetchDepartmentsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsCompLoading(false);
	}



	function fetchUserDepartments(searchValueInput) {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsUserLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true,
				companyId: initialValues.companyId,
				loginId: initialValues.loginId,
				searchValue: searchValueInput,
				userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserDepartment", "/Service/UserService/GetUserDepartment", requestOptions, retrieveUserDepartmentSuccess, retrieveUserDepartmentFail);
		} catch (error) {
			setIsUserLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserDepartmentFail(redirect) {
		setIsUserLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.deptNotRetrieved"));
	}

	function retrieveUserDepartmentSuccess(responseData) {
		let fetchUserDepartmentsResponse;
		if (responseData) {
			fetchUserDepartmentsResponse = responseData.fetchUserDepartmentsResponse;
			if (fetchUserDepartmentsResponse && fetchUserDepartmentsResponse.errorCode === "0") {
				setUserDepartments(fetchUserDepartmentsResponse.departments.slice())
			} else if (fetchUserDepartmentsResponse && fetchUserDepartmentsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserDepartmentsResponse) {
				setError(t("error.error") + " " + fetchUserDepartmentsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserLoading(false);
	}

	const handleDeleteClick = (event, userDeptItem, completeCallback) => {
		event.preventDefault();
		deleteUserDepartment(userDeptItem, completeCallback);
	};
	const deleteUserDepartment = (userDeptItem, completeCallback) => {
		let action = 3;
		if (userDeptItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			departmentKey: userDeptItem.departmentKey,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserDepartment", "/Service/UserService/DeleteUserDepartment", requestOptions, deleteUserDepartmentSuccess, deleteUserDepartmentFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteUserDepartmentFail(redirect, completeCallback) {
		setError(t("error.userDeptEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteUserDepartmentSuccess(responseData, completeCallback) {
		let deleteUserDepartmentResponse;
		if (responseData) {
			deleteUserDepartmentResponse = responseData.deleteUserDepartmentResponse;
			if (deleteUserDepartmentResponse) {
				if (deleteUserDepartmentResponse.errorCode === "0") {
					resetRowTable();
					fetchUserDepartments(searchValue);
				} else {
					setError(t("error.error") + " " +
						deleteUserDepartmentResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (userDepartments.length > 0) {
				userDepartments.map((userDeptItem, index) => {
					if (userDeptItem.departmentKey === setValues.departmentKey) {
						setError(t("error.userDeptDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveUserDepartment(action, setValues, completeCallback);
			}
		}
	};
	const saveUserDepartment = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			departmentKey: setValues.departmentKey,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserDepartment", "/Service/UserService/AddUpdateUserDepartment", requestOptions, saveUserDepartmentSuccess, saveUserDepartmentFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveUserDepartmentFail(redirect, completeCallback) {
		setError(t("error.userDeptEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveUserDepartmentSuccess(responseData, completeCallback) {
		let addUpdateUserDepartmentResponse;
		if (responseData) {
			addUpdateUserDepartmentResponse = responseData.addUpdateUserDepartmentResponse;
			if (addUpdateUserDepartmentResponse) {
				if (addUpdateUserDepartmentResponse.errorCode === "0") {
					resetRowTable();
					fetchUserDepartments(searchValue);
				} else {
					setError(t("error.error") + " " +
						addUpdateUserDepartmentResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const valueHandler = (e) => {
		const { name, value } = e.target;
		if (typeof value === 'undefined') {
			value = "";
		}
		setSearchValue(value);
	}
	const searchHandler = (e) => {
		fetchUserDepartments(searchValue);
	}
	const onClickClear = (e) => {
		setSearchValue("");
		fetchUserDepartments("");
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isCompLoading || isUserLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col mt-3">
							<input type="text" id="searchData" value={searchValue} placeholder={t("page.search.plc")} className="search-text" onChange={(e) => valueHandler(e)} />&nbsp;
							<button type="submit" className="btn btn-primary btn-block search-button" onClick={searchHandler} >
								<span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
							</button>
							<button className="btn btn-primary btn-block search-clear" onClick={onClickClear}>{t("page.clear")}
							</button>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.dept.name")}</th>
										<th className="list-th">{t("page.dept.type")}</th>
										<th className="list-th">{t("page.address")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th">
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<UserDepartmentTableRow
											index={count}
											compDepartments={compDepartments}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDepartments.length % 2) > 0) ? true : false} />
									}
									{(userDepartments.length > 0) ? (
										userDepartments.map((userDeptItem, index) => (
											<UserDepartmentReadOnlyRow
												index={count}
												t={t}
												userDeptItem={userDeptItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												add={add}
												setError={setError}
												handleSubmit={handleSubmit}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<UserDepartmentTableRow
											index={count}
											compDepartments={compDepartments}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDepartments.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(userDepartments.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.dept.name")}</th>
										<th className="list-th">{t("page.dept.type")}</th>
										<th className="list-th">{t("page.address")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th">
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-user-dept-close"
									id="edit-user-dept-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserDepartmentTable;